import React, { Component } from 'react';
import { connect } from 'react-redux';

class ViewMoreResultsAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
closeAlert = () => {
  this.props.updateCanViewMoreResultsAlert(false);
}
linkToPricingPage = () => {
  this.props.history.push({ pathname: '/pricing' });
}
  render() {
      return (
        <div className="alert-container fade-in">
  				<div className="row d-flex justify-content-center">
  					<div className="col-sm-10 col-md-7 text-center">
  						<div
  							className="alert alert-info alert-onboarding"
  							role="alert"
  							data-color="info"
  							onClick={() => this.closeAlert()}>
  							<div className="d-flex justify-content-between">
  								<span className="alert-copy">
  								  Please <u onClick={() => this.linkToPricingPage()}>upgrade</u> to view more results
  								</span>
  								<i className="fas fa-times fa-sm alert-close"></i>
  							</div>
  						</div>
  					</div>
  				</div>
  			</div>
      );
    }
}
const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
  return {
        updateCanViewMoreResultsAlert: (canViewMoreResultsAlert) => dispatch({ type: 'CAN_VIEW_MORE_RESULTS_ALERT', value: canViewMoreResultsAlert })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewMoreResultsAlert);
